// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import { addressDrawerContainerStyles } from "@insite/content-library/Widgets/Header/AddressDrawerContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerShipToAddressStyles.drawer = {
    closeButtonProps: {
        shape: "pill",
        buttonType: "solid",
        color: "common.background",
        size: 36,
    },
    closeButtonIconProps: {
        src: "X",
        size: 24,
    },
    cssOverrides: {
        drawerContent: css`
            height: 100%;
            overflow-y: inherit;
        `,
        drawerBody: css`
            background: ${getColor("common.background")};
            height: 375px;
            overflow-x: inherit;
            overflow-y: inherit;
            top: 50%;
            transform: translateY(-50%);
            padding: 0 50px 20px 50px;
            height: auto;
            min-height: 260px;
        `,
        drawerTitle: css`
            background: ${getColor("common.background")};
        `,
    },
    headlineTypographyProps: {
        color: "text.main",
    },
};
